require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ../~/angular-animate/index.js
// module id = 376
// module chunks = 1